export default __webpack_public_path__ + "images/nav-bar.svg";